import { useEffect } from 'react';
import { useAllCardsStore, useCardsLatestStore, useFeedStore, useServicesStore } from '@lib/store';
import { PageLayout } from '@shared/widgets';
import { Preloader } from '@shared/widgets/preloader';
import { InsigniaCards } from '@widgets/insigniaCard';
import InsigniaCardsIcon from '@assets/images/insignia_cards_ico.svg';

export const ProductsPage = () => {
  const allCardsStore = useAllCardsStore();
  const cardsLatestStore = useCardsLatestStore();
  const feedStore = useFeedStore();
  const servicesStore = useServicesStore();

  useEffect(() => {
    setTimeout(() => {
      allCardsStore.get();
      cardsLatestStore.get();
      feedStore.getFeed(4);
      servicesStore.getServices();
    }, 250);
  }, []);

  if (!allCardsStore.data || !feedStore.data || !servicesStore.data) return <Preloader />;
  return (
    <PageLayout>
      <InsigniaCardsIcon className='mx-auto mt-4 mb-12 hidden max-md:block' />
      <div className='bg-[#fafafa] pb-[50px] max-md:relative'>
        <InsigniaCards />
      </div>
    </PageLayout>
  );
};
